export enum CatalogActionTypes {
    FETCH_UNIVERSES = 'FETCH_UNIVERSES',
    FETCH_CATEGORIES = 'FETCH_CATEGORIES',
    FETCH_PRODUCTS = 'FETCH_PRODUCTS',
    PUSH_IN_HISTORY = "PUSH_IN_HISTORY"
}
